// extracted by mini-css-extract-plugin
export default {"removeButton":"YFv2onuunKMQM7_y26SA","brand":"lnvoe4bJteUorEocOoz9"};